import { useState } from 'react';
import {
  Box,
  Table as MaterialTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  useTheme,
} from '@mui/material';
import { IconBtn } from '../IconBtn/IconBtn';
import { Close } from '../../icons/Close/Close';
import {
  tableContainerSx,
  tableIconBtnSx,
  tablePaginationSx,
  tableRowSx,
} from './Table.style';
import {
  boxContainerSx,
  centerTextSx,
  font500Sx,
} from '../../styles/Global.style';
import { Copy } from '../../copy/Copy';

export const Table = ({
  columns,
  rows,
  allowDelete = false,
  showPosition = false,
  positionTitle,
  toggleDeleteModal,
  total,
  totalText = Copy.generate('Tables.labels.totalDistance'),
  sx,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const theme = useTheme();
  const color = theme.palette.secondary.main;

  const handleChangePage = (e, newPage) => {
    e.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  return (
    <Box sx={{ ...boxContainerSx, ...sx }}>
      <TableContainer sx={tableContainerSx}>
        <MaterialTable stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {showPosition && (
                <TableCell sx={{ color, ...font500Sx, ...centerTextSx }}>
                  {positionTitle}
                </TableCell>
              )}

              {columns.map((column, i) => (
                <TableCell
                  key={`table-head-${i}`}
                  sx={{
                    color,
                    ...font500Sx,
                    ...centerTextSx,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}

              {allowDelete && <TableCell></TableCell>}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, i) => (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={`table-row-${i}`}
                  sx={tableRowSx(theme)}
                >
                  {showPosition && (
                    <TableCell sx={{ color, ...centerTextSx }}>
                      {page === 0 ? i + 1 : i + 1 + page * rowsPerPage}
                    </TableCell>
                  )}

                  {columns.map((column, i) => (
                    <TableCell
                      key={`table-cell-${i}`}
                      sx={{ color, ...centerTextSx }}
                    >
                      {row[column.id]}
                    </TableCell>
                  ))}

                  {allowDelete && (
                    <TableCell>
                      <IconBtn
                        icon={<Close size="small" />}
                        onClick={() =>
                          toggleDeleteModal({ activityId: row.id })
                        }
                        color={theme.palette.tertiary.main}
                        sx={tableIconBtnSx}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}

            {total && (
              <TableRow tabIndex={-1} sx={tableRowSx(theme)}>
                <TableCell
                  sx={{ color, ...centerTextSx, ...font500Sx }}
                  colSpan={2}
                >
                  {totalText}
                </TableCell>
                <TableCell sx={{ color, ...centerTextSx }}>{total}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </MaterialTable>

        <TablePagination
          rowsPerPageOptions={[5, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={tablePaginationSx(color)}
        />
      </TableContainer>
    </Box>
  );
};
